export const initHomeTestimonials = (element: HTMLElement) => {
    const offset: number = 20;
    const rowTop = element.querySelector<HTMLElement>('[data-row="top"]')!;
    const rowBottom = element.querySelector<HTMLElement>('[data-row="bottom"]')!;
    const bottomOffset = offset * 2;

    rowBottom.style.transform = `translateX(-${bottomOffset}vw)`;

    function updateScroll() {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        const start = rect.top - windowHeight;
        const end = rect.bottom;
        const progress = Math.min(Math.max((windowHeight - rect.top) / (rect.height + windowHeight), 0), 1);

        const translateValue = offset * progress; // from 0 to 20

        rowTop.style.transform = `translateX(-${translateValue}vw)`;
        rowBottom.style.transform = `translateX(${-bottomOffset + translateValue}vw)`;
    }

    window.addEventListener('scroll', updateScroll, {passive: true});
    window.addEventListener('resize', updateScroll);
    updateScroll();

}